import React from "react"
import VerifylinkResendLayout from "../../components/Lystface/Helper/Verification/VerifylinkResendLayout"
import BackgroundAuthentication from "../../components/Lystface/Common/BackgroundAuthentication"

const SignupSuccess = () => {

    return (
        <>
            <BackgroundAuthentication Image={true} form={<VerifylinkResendLayout from="verify-email" />} />
        </>
    )
}

export default SignupSuccess
